module.exports = __webpack_public_path__ + "img/pending.7e1a668a.svg";